// extracted by mini-css-extract-plugin
module.exports = {"widgetButtonsBar":"WidgetButtonsBar_widgetButtonsBar__2iRvP","rightSide":"WidgetButtonsBar_rightSide__3R2Fp","chartButtonActive":"WidgetButtonsBar_chartButtonActive__GCzWD"};